export type UploadMediaResponseType = {
    min_thumbnail_url?: string;
    s3_key?: string;
    image_url?: string;
    s3_key_min_thumbnail?: string;
    s3_key_medium_thumbnail?: string;
    medium_thumbnail_url?: string;
};

export const avatarImageConfig = {
    minWidth: 148,
    minHeight: 148,
    maxSize: 1024,
    allowedExtensions: ['.jpeg', '.jpg', '.png'],
    repository: 'profile_picture'
};

export const companyLogoImageConfig = {
    minWidth: 240,
    minHeight: 240,
    maxSize: 1024,
    allowedExtensions: ['.jpeg', '.jpg', '.png', '.svg', '.bmp', '.ico', '.gif', '.webp'],
    repository: 'company_logo'
};

export const dashboardCustomizationConfig = {
    minWidth: 500,
    minHeight: 500,
    maxSize: 5120,
    allowedExtensions: ['.jpg', '.jpeg', '.png'],
    repository: 'dashboard'
};

export const widgetImageConfig = {
    minWidth: 340,
    minHeight: 340,
    maxSize: 2048,
    allowedExtensions: ['.jpeg', '.jpg', '.png'],
    repository: 'dashboard',
    upload_type: 'dashboard_widget_image'
};

export const spGroupImageConfig = {
    minWidth: 200,
    minHeight: 200,
    maxSize: 1024,
    allowedExtensions: ['.jpeg', '.jpg', '.png'],
    repository: 'group',
    upload_type: 'group_image'
};

export const schedulerVideoThumbnailImageConfig = {
    minWidth: 500,
    minHeight: 500,
    maxSize: 8000,
    allowedExtensions: ['.jpeg', '.jpg']
};
